<template>
	<div id="eventdaily" style="height:800px;width: 100%;position: relative;background-color: #F3F3F5;overflow: scroll;">
		<h3>24H内告警走势图</h3>
		
		<div class="myChart" style="background-color: red;" ref='mychart'>
		
		</div>
		<div class="myChart">
			
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	
	export default{
		data(){
			return{
				charts:'',
			}
		},
		methods:{
			drawLine(){
				this.charts = echarts.init(this.$refs.mychart);
			}
		}
	}
</script>

<style>
	.myChart{
		width: 100%;
		height: 500px;
	}
</style>
